import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EncryptionService } from '@shared/encryption/services/encryption.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [
        EncryptionService
    ]
})
export class BavelEncryptionModule { }
